var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1808 0H13.0492C5.93145 0 0 5.93221 0 13.0509V42.9492C0 50.3051 5.93145 56 13.0492 56H42.9439C50.2989 56 55.9931 50.0678 55.9931 42.9492V13.0509C56.2304 5.69492 50.2986 0 43.1808 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0974 9.72852C37.4876 9.72852 35.5895 10.4404 34.166 12.1014C32.9797 10.4404 31.0816 9.72852 28.2345 9.72852C24.6757 9.72852 20.8799 12.1014 20.8799 16.6099C20.8799 22.3048 25.1505 27.5251 33.9291 32.2709C42.7076 27.5251 46.9783 22.3048 46.9783 16.6099C47.2155 12.1014 43.6563 9.72852 40.0974 9.72852Z",
    fill: "url(#paint0_linear_12885_14271)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12885_14271",
    x1: 34.2043,
    y1: 9.72163,
    x2: 34.2043,
    y2: 32.1727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC57A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF200C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleHealth);
export default __webpack_public_path__ + "static/media/apple-health.a346071a2bf37ac68f47824701d10bc1.svg";
export { ForwardRef as ReactComponent };